<template>
   <v-container fluid style=""> 
    <v-row v-if="tableConfig && (tableConfig.moduleLink || tableConfig.search || tableConfig.menu)">
        <div class="d-flex align-center justify-space-between pa-2 mt-2"  style="width: 100%; height: 72px;">
            <SearchPanel v-on:change="onFilterChange" :config="childrenConfig" :context="childrenContext"></SearchPanel>
            <div v-if="tableConfig && tableConfig.moduleLink" align="right" style="padding: 6px; margin-right:10px;">
                <a :href="tableConfig.moduleLink.href">{{st(tableConfig.moduleLink.title)}}</a>
            </div>
            <div v-if="tableConfig && tableConfig.menu && tableConfig.menu.length>0" align="right" style="padding: 6px; margin-right:10px;">
                <MenuPanel v-on:menu-selected="onMenuSelected" :config="childrenConfig" :context="childrenContext"></MenuPanel>
            </div>
        </div>
    </v-row>
    <ExportXlsx
                    ref="exportXlsx"
                    style ="visibility:hidden;"
                    :data="data"
                    :columns="headers"
                    :file-name="'tweem_export'"
                    :sheet-name="'tweem'"
                    >
                </ExportXlsx>
    <v-row style="width:100%; margin: 0;">
      <v-data-table :loading="isLoading" :disableFiltering="true"
            :headers="headers" :class="`${config&&config.fullScreenDialog?'full-screen-dialog ':''}${tableConfig.onRowSelect?'row-pointer':''}`"
						ref = "dataTable"
						:loading-text="$t('wkt.admin.common.table.loading')"
						:no-data-text="$t('wkt.admin.common.table.no_data')"
						:no-results-text="$t('wkt.admin.common.table.no_results')"
            :options.sync="options" 
			:server-items-length="serverItems"
            :items="data" 
						:disablePagination="true" 
            :fixedHeader="true" 
						:height="tableHeight" 
						style="max-height: calc(100vh - 100px); width: 100%;"
            :footer-props="{
						'items-per-page-text': $t('wkt.admin.common.table.items_per_page'),
						'items-per-page-all-text': $t('wkt.admin.common.table.items_per_page_all'),
                        'items-per-page-options': itemsPerPageList,
					}"
            @click:row="onRowSelected"
        >
        
        <template v-slot:[`footer.page-text`]="props">
          {{ props.pageStart }} - {{ props.pageStop }} {{ $t('wkt.admin.paged-tables.pager.of') }} {{ props.itemsLength > props.pageStop ? `+${props.pageStop}` : props.pageStop }}
        </template>

        <template v-slot:[`footer.prepend`]>           
            <RefreshWidget ref="refresh" :style="`position: fixed; left: ${config&&config.fullScreenDialog ? 425 : 'auto'};`" @refresh="updateData()" />
        </template>

        <template v-slot:[`item.avatar`]="{ item }">
               <v-img max-width="38" max-height="38" :src="getProfileAssetUrl(item.avatar_url)" style="float:left; margin: 5px;"></v-img>
               <div style=" margin: 5px;">
                <span v-if="item.avatar_title" class="truncate" style="display: block; white-space:nowrap;">{{item.avatar_title}}</span>
                <span v-if="item.avatar_subtitle" style="display: block; white-space:nowrap; color: grey;">{{item.avatar_subtitle}}</span>
                </div>
            </template>

            <template v-slot:[`item.composite1`]="{ item }">
               <v-img v-if="item.composite1_url" max-width="38" max-height="38" :src="getProfileAssetUrl(item.composite1_url)" style="float:left; margin: 5px;"></v-img>
               <div style=" margin: 5px;">
                <span v-if="item.composite1_title" class="truncate" :style="'display: block; white-space:nowrap; color: '+(item.composite1_title_color?item.composite1_title_color:'unset')+';'">{{st(item.composite1_title)}}</span>
                <span v-if="item.composite1_subtitle"  :style="'display: block; white-space:nowrap; color: '+(item.composite1_subtitle_color?item.composite1_subtitle_color:'grey')+';'">{{st(item.composite1_subtitle)}}</span>
                </div>
            </template>

            <template v-slot:[`item.composite2`]="{ item }">
               <v-img v-if="item.composite2_url" max-width="38" max-height="38" :src="getProfileAssetUrl(item.composite2_url)" style="float:left; margin: 5px;"></v-img>
               <div style=" margin: 5px;">
                <span v-if="item.composite2_title" class="truncate" :style="'display: block; white-space:nowrap; color: '+(item.composite2_title_color?item.composite2_title_color:'unset')+';'">{{st(item.composite2_title)}}</span>
                <span v-if="item.composite2_subtitle"  :style="'display: block; white-space:nowrap; color: '+(item.composite2_subtitle_color?item.composite2_subtitle_color:'grey')+';'">{{st(item.composite2_subtitle)}}</span>
                </div>
            </template>

            <template v-slot:[`item.composite3`]="{ item }">
               <v-img v-if="item.composite3_url" max-width="38" max-height="38" :src="getProfileAssetUrl(item.composite3_url)" style="float:left; margin: 5px;"></v-img>
               <div style=" margin: 5px;">
                <span v-if="item.composite3_title" class="truncate" :style="'display: block; white-space:nowrap; color: '+(item.composite3_title_color?item.composite3_title_color:'unset')+';'">{{st(item.composite3_title)}}</span>
                <span v-if="item.composite3_subtitle" :style="'display: block; white-space:nowrap; color: '+(item.composite3_subtitle_color?item.composite3_subtitle_color:'grey')+';'">{{st(item.composite3_subtitle)}}</span>
                </div>
            </template>

             <template v-slot:[`item.composite3_1`]="{ item }">
                <div v-if="item.total_amount > 0 && item.invoice_number" style="margin: 5px;">
                    <v-btn text @click.stop="downloadPurchaseBill(item.id)">
                        <v-icon color="#00BFD2">link</v-icon>
                    </v-btn>
                </div>
            </template>

             <template v-slot:[`item.composite3_2`]="{ item }">
                <div>
                   <span v-if="item.composite3_2_companyName == null || !item.composite3_2_companyName" class="d-flex justify-center align-center" :style="'height: 30px; color: black; font-size: 12px; '">{{""}}</span>    
                   <span v-if="item.composite3_2_companyName" class="d-flex justify-start align-center" :style="'height: 30px; color: black; font-size: 12px; '">{{st(item.composite3_2_companyName)}}</span>  
                   <span v-if="item.composite3_2_companyId == null" class="d-flex justify-start align-center" :style="'height: 30px; color: black; font-size: 12px; '">{{""}}</span>               
                   <span v-if="item.composite3_2_companyId" class="d-flex justify-start align-center" :style="'height: 30px; color: grey; font-size: 11px; '">{{st(item.composite3_2_companyId)}}</span>                                   
                </div>
            </template>

            <!--eslint-disable-next-line no-unused-vars-->

            <template v-slot:[`item.composite4`]="{ item }">
              <div class="d-flex align-center" style="height: 30px;">
								<div v-if="item.composite4_color" :style="'float:left; margin: 5px; width: 30px; height: 30px; border: 1px solid grey; border-radius: 50%; background-color: ' + convertColorToHex(item.composite4_color)">
									<span v-if="item.composite4_subtitle" class="d-flex justify-center align-center" :style="'height: 30px; color: black; font-size: 12px; '">{{st(item.composite4_subtitle)}}</span>             
								</div>
								<span v-if="item.composite4_title" class="truncate" :style="'margin: 5px; min-width: 200px; max-width: 200px; display: block; white-space:nowrap; color: unset;'">{{st(item.composite4_title)}}</span>
							</div>
            </template>

            <template v-slot:[`item.composite5`]="{ item }">
                <div v-if="item.composite5_firstname || item.composite5_lastname || item.composite5_email" style="margin: 5px;">
                    <span v-if="item.composite5_firstname || item.composite5_lastname" class="text-truncate" style="display: block; max-width: 200px; white-space:nowrap;">{{`${item.composite5_firstname} ${item.composite5_lastname?item.composite5_lastname:''}`.trim()}}</span>
                    <span v-if="item.composite5_email" class="text-truncate" style="max-width: 200px; color: unset;">{{st(item.composite5_email)}}</span>
                    </div>				
                <div v-else style="margin: 5px;">
                    <span>{{st('wkt.admin.complaint.anonymous')}}</span>             
                </div>
            </template>

            <template v-slot:[`item.composite6`]="{ item }">
                <div style="margin: 5px;">
                    <span>{{`${item.composite6_firstname} ${item.composite6_lastname}`}}</span>          
                </div>
            </template>

            <template v-slot:[`item.composite7`]="{ item }">
                <div v-if="item.composite7_response_code != null && item.composite7_response_code == '0000' && item.composite7_refundDate == null" style=" margin: 5px;">
                        <v-icon color="#00BFD2">credit_card</v-icon>
                </div>
                <div>
                <span v-if="item.composite7_refundDate" class="truncate" :style="'margin: 5px; min-width: 200px; max-width: 200px; display: block; white-space:nowrap; color: unset;'">{{formatDateTime(item.composite7_refundDate)}}</span>       
                </div>
            </template>
            
            <template v-slot:[`item.composite8`]="{ item }">
                <div class="d-flex align-center" style="height: 30px;">
                    <div>
                        <span v-if="item.composite8_transaction_type != null && item.composite8_transaction_type == '0'" class="d-flex justify-center align-center" :style="'height: 30px; color: green; font-size: 14px; '">Pago manual</span> 
                        <span v-if="item.composite8_transaction_type != null && item.composite8_transaction_type == 'A'" class="d-flex justify-center align-center" :style="'height: 30px; color: green; font-size: 14px; '">Pago auto.</span>   
                        <span v-if="item.composite8_transaction_type != null && item.composite8_transaction_type == '3'" class="d-flex justify-center align-center" :style="'height: 30px; color: red; font-size: 14px; '">Devolución</span>            
                    </div>
                </div>
            </template>

            <template v-slot:[`item.composite_notify_receiver`]="{ item }">
                <div v-if="item.composite_notify_receiver_type == 0">
                    <div v-if="item.composite_notify_receiver_employees != null">
                        <span style="display: block; max-width: 600px; white-space:nowrap;">
                            {{`${getReceiversByEmployees(item.composite_notify_receiver_employees)}`}}
                        </span>
                    </div>
                    <div v-else>
                        <div v-if="item.composite_notify_receiver_workplaces == null && item.composite_notify_receiver_departments == null && item.composite_notify_receiver_legal_entities == null">
                            <span style="display: block; max-width: 250px; white-space:nowrap;">
                                {{ $t('wkt.admin.common.all') }}
                            </span>
                        </div>
                        <div v-else>
                            <span style="display: block; max-width: 350px; white-space:nowrap;">
                                {{`${getReceiversByWorkplaces(item.composite_notify_receiver_workplaces)}`}}, {{`${getReceiversByDepartments(item.composite_notify_receiver_departments)}`}}
                            </span>
                            <span v-if="item.composite_notify_receiver_legal_entities" style="display: block; max-width: 350px; white-space:nowrap;">
                                {{`${getReceiversByLegalEntities(item.composite_notify_receiver_legal_entities)}`}}
                            </span>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div v-if="item.composite_notify_receiver_type == 1">
                        <span v-if="!item.composite_notify_receiver_workplaces && !item.composite_notify_receiver_departments && !item.composite_notify_receiver_legal_entities" style="display: block; max-width: 250px; white-space:nowrap;">{{ $t('wkt.admin.common.all') }}</span>
                        <span v-else style="display: block; max-width: 350px; white-space:nowrap;">
                            {{`${getReceiversByWorkplaces(item.composite_notify_receiver_workplaces)}`}}, {{`${getReceiversByDepartments(item.composite_notify_receiver_departments)}`}}
                        </span>
                        <span v-if="item.composite_notify_receiver_legal_entities" style="display: block; max-width: 350px; white-space:nowrap;">
                            {{`${getReceiversByLegalEntities(item.composite_notify_receiver_legal_entities)}`}}
                        </span>
                    </div>
                    <div v-else-if="item.composite_notify_receiver_type == 2">
                        <span style="display: block; max-width: 350px; white-space:nowwrap;">
                            {{`${getReceiversByWorkplaces(item.composite_notify_receiver_workplaces)}`}}, {{`${getReceiversByDepartments(item.composite_notify_receiver_departments)}`}}
                        </span>
                        <span v-if="item.composite_notify_receiver_legal_entities" style="display: block; max-width: 350px; white-space:nowrap;">
                            {{`${getReceiversByLegalEntities(item.composite_notify_receiver_legal_entities)}`}}
                        </span>
                    </div>
                    <div v-else-if="item.composite_notify_receiver_type == 6">
                        <span style="display: block; max-width: 450px; white-space:nowrap;">
                            {{`${getReceiversByProjects(item.composite_notify_receiver_projects)}`}}
                        </span> 
                    </div>
                    <div v-else-if="item.composite_notify_receiver_type == 3 ||item.composite_notify_receiver_type == 4 || item.composite_notify_receiver_type == 5">
                        <span :style="'display: block; max-width: 300px; color:' + (getCurrentUserId !== null && item.avatar_notify_sender_id !== getCurrentUserId ? 'orange' : 'black') + ';'">
                            {{`${getReceiversByEmployees(item.composite_notify_receiver_employees)}`}}
                        </span>
                    </div>
                </div>
            </template>

            <template v-slot:[`item.composite13`]="{ item }">
                  <div class="d-block align-center" style="margin: 5px; justify-content: center; align-items: center;">
                    <div>
                     <span v-if="item.composite13_accessType == 1"  style="display: block; max-width: 200px; white-space:nowrap;">{{ $t('wkt.admin.activity-types.edit-activity-types.access-type_company') }}</span>  
                    </div> 
                    <div>
                     <span v-if="item.composite13_accessType == 2"  style="display: block; max-width: 200px; white-space:nowrap;">{{`${getReceiversByWorkplaces(item.composite13_workplaces)}`}}</span>  
                    </div>   
                    <div>
                     <span v-if="item.composite13_accessType == 2"  style="display: block; max-width: 200px; white-space:nowrap;">{{`${getReceiversByDepartments(item.composite13_departments)}`}}</span>  
                    </div>  
                    <div>
                     <span v-if="item.composite13_accessType == 2 && item.composite13_legal_entities" style="display: block; max-width: 200px; white-space:nowrap;">{{`${getReceiversByLegalEntities(item.composite13_legal_entities)}`}}</span>
                    </div>
                    <div>
                      <span v-if="item.composite13_accessType == 3"  style="display: block; max-width: 200px; white-space:nowrap;">{{`${getReceiversByProjects(item.composite13_projects)}`}}</span>   
                    </div> 
                    <div>
                      <span v-if="item.composite13_accessType == 4"  style="display: block; max-width: 200px; white-space:nowrap;">{{`${getReceiversByEmployees(item.composite13_employees)}`}}</span>   
                    </div> 
                    <div>
                      <span v-if="item.composite13_accessType == 5"  style="display: block; max-width: 200px; white-space:nowrap;">{{$t('wkt.admin.activity-types.edit-activity-types.access-type_script')}}</span>   
                    </div> 
                </div>
            </template>

            <template v-slot:[`item.avatar_disabled_telework_employee`]="{ item }">
               <v-img max-width="38" max-height="38" :src="getProfileAssetUrl(item.avatar_disabled_telework_employee_url)" style="float:left; margin: 5px;"></v-img>
               <div style=" margin: 5px;">
                <span v-if="item.avatar_disabled_telework_employee_title" :style="'display: block; white-space:wrap; color: ' + (item.is_enabled ? 'unset' : 'red') + ';'">{{`${item.avatar_disabled_telework_employee_title}${(item.is_enabled ? '' : ' (' + st('wkt.admin.edit-employee-window.disabled') + ')')}`}}</span>
                <span v-if="item.avatar_disabled_telework_employee_subtitle" :style="'display: block; white-space:nowrap; color: ' + (item.is_enabled ? 'unset' : 'red') + ';'">{{item.avatar_disabled_telework_employee_subtitle}}</span>
                </div>
            </template>

            <template v-slot:[`item.composite_status_telework_employee`]="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                            <v-icon :color="getIconColor(item)">
                                {{ getIconType(item) }}
                            </v-icon>
                        </div>
                    </template>
                    <span>{{ getTooltipText(item) }}</span>
                </v-tooltip>
            </template>

            <template v-slot:[`item.composite_available_telework_employee`]="{ item }">
                 <div v-if="item.composite_status_telework_employee_telework == '1'">
                     <span v-if="item.composite_available_telework_employee_start">
                         {{ `${getHoursMins(item.composite_available_telework_employee_start)} ` }} 
                     </span>
                     <span v-if="item.composite_available_telework_employee_end">
                        {{ `- ${getHoursMins(item.composite_available_telework_employee_end)}` }}
                    </span>
                 </div>
             </template>
             
             <template v-slot:[`item.telework_notes`]="{ item }">
                <div v-if="item.composite_status_telework_employee_telework == '1'">
                    <span v-if="item.telework_notes">
                        {{ item.telework_notes }}
                    </span>
                </div>
             </template>
            
            <template v-slot:[`item.composite_expensesheet_approval`]="{ item }">
                <span style="display: block; max-width: 200px;">{{ item.composite_expensesheet_approval_employees }}</span>
                <span class="text-truncate" style="max-width: 200px; color: unset;">{{ formatLongDateTime(item.composite_expensesheet_approval_date) }}</span>
            </template>

            <!--<template v-slot:[`item.composite_expensesheet_status`]="{ item }">
                <span :style="`display: block; max-width: 200px; white-space:nowrap; color:${getExpenseSheetStatusColor(item.composite_expensesheet_status)}`">{{ getExpenseSheetStatusText(item.composite_expensesheet_status) }}</span>
            </template>-->
             
             <template v-slot:[`item.composite_expensesheetitem_expense_description`]="{ item }">
                <span style="display: block; max-width: 200px; white-space: wrap;">{{ item.composite_expensesheetitem_expense_description }}</span>
            </template>

            <template v-slot:[`item.composite_expensesheetitem_taxes`]="{ item }">
                <div class="d-flex align-center">
                    <span v-if="item.composite_expensesheetitem_taxes_percent" style="max-width: 200px;">{{ `${item.composite_expensesheetitem_taxes_percent * 100} %` }}</span>
                    <span v-if="item.composite_expensesheetitem_taxes_amount" class="ml-1" style="display: block; color: grey;">{{ ` (${item.composite_expensesheetitem_taxes_amount})` }}</span>
                    </div>
            </template> 

            <template v-slot:[`item.composite_expensesheetitem_vendor`]="{ item }">
                <div>
                    <span v-if="item.composite_expensesheetitem_vendor_name" class="text-truncate" style="display: block; max-width: 200px; white-space: nowrap;">{{ item.composite_expensesheetitem_vendor_name }}</span>
                    <small v-if="item.composite_expensesheetitem_vendor_vat_number" class="text-truncate" style="max-width: 200px; color: grey;">{{ item.composite_expensesheetitem_vendor_vat_number }}</small>
                </div>
            </template>

            <template v-slot:[`item.composite_expensesheetitem_attachment`]="{ item }">
                <a v-if="item.composite_expensesheetitem_attachment" class="text-decoration-underline" style="display: block; max-width: 200px; white-space: wrap;" @click.stop="downloadExpenseSheetItemDocument(item)">{{ item.composite_expensesheetitem_attachment }}</a>
			</template>

            <template v-slot:[`item.composite_team_info`]="{ item }">
                <div>
                    <div style="margin-top: 2px;">
                        <div v-if="item.composite_team_color" :style="'float:left; margin-right: 10px; width: 25px; height: 18px; background-color: ' + convertColorToHex(item.composite_team_color)"></div>
                    
                        <!-- Mostrar el nombre del proyecto y la referencia si existe -->
                        <span v-if="item.composite_team_short_name && item.composite_team_internal_code" class="truncate" style="display: block; max-width: 220px; white-space: nowrap;">
                            {{ item.composite_team_short_name }} - {{ item.composite_team_internal_code }}
                        </span>
                        
                        <!-- Mostrar solo el nombre del proyecto si no hay referencia -->
                        <span v-else-if="item.composite_team_short_name" class="text-truncate" style="display: block; max-width: 220px; white-space: nowrap;">
                            {{ item.composite_team_short_name }}
                        </span>
                    </div>
                    
                    <!-- Mostrar la descripción del proyecto -->
                    <span v-if="item.composite_team_description" style="display: block; max-width: 220px; white-space:wrap; font-size: 0.8em; color: grey;">
                        {{ item.composite_team_description }}
                    </span>
                </div>
            </template>

            <template v-slot:[`item.composite_team_employees`]="{ item }">
                <div>
                    <!-- Mostrar los primeros 15 trabajadores que pertenecen al proyecto -->
                    <span>{{ item.composite_team_employees }}</span>
                    <span v-if="item.num_team_employees > 15">
                        {{ ` ... ${st('wkt.admin.teams.and_n_more').replace('%d', item.num_team_employees - 15)}` }}
                    </span>
                </div>
            </template>

            <template v-slot:[`item.composite_project_managers`]="{ item }">
                <div>
                    <!-- Mostrar los primeros 15 responsables del proyecto -->
                    <span>{{ item.composite_project_managers }}</span>
                    <span v-if="item.num_project_managers > 15">
                        {{ ` ... ${st('wkt.admin.teams.and_n_more').replace('%d', item.num_project_managers - 15)}` }}
                    </span>
                </div>
            </template>

            <template v-slot:[`item.avatar_disabled_admin_profiles`]="{ item }">
                <div style="display:flex;">
                    <v-img max-width="38" max-height="38" :src="getProfileAssetUrl(item.avatar_disabled_admin_profiles_url)" style="float:left; margin: 5px;"></v-img>
                    <div style=" margin:12px;">
                        <span v-if="item.avatar_disabled_admin_profiles_title" :style="'display: block; white-space:wrap; color: ' + (item.avatar_disabled_admin_profiles_disabled ? 'unset' : 'red') + ';'">{{`${item.avatar_disabled_admin_profiles_title}${(item.avatar_disabled_admin_profiles_disabled ? '' : ' (' + st('wkt.admin.edit-employee-window.disabled') + ')')}`}}</span>
                    </div>
                </div>
            </template>

            <template v-slot:[`item.composite_admin_profiles_employee`]="{ item }">
                <div style="margin:5px;">
                    <span v-if="item.composite_admin_profiles_employee_email" class="truncate" style="display: block; white-space:nowrap;">{{ truncateEmail(item.composite_admin_profiles_employee_email) }}</span>
                    <span v-if="item.composite_admin_profiles_employee_company_name" style="display: block; white-space:nowrap; color: grey;">{{ item.composite_admin_profiles_employee_company_name }}</span>
                </div>
            </template>

            <template v-slot:[`item.composite_admin_profiles_receiver_workplaces`]="{ item }">
                <div class="d-block align-center" style="margin: 5px; justify-content: center; align-items: center;">
                    <span v-if="item.composite_admin_profiles_receiver_workplaces"  style="display: block; white-space:nowrap;">{{`${getReceiversByWorkplaces(item.composite_admin_profiles_receiver_workplaces)}`}}</span>
                    <span v-else>{{$t('wkt.admin.common.all')}}</span>
                </div>
            </template>

            <template v-slot:[`item.composite_admin_profiles_receiver_departments`]="{ item }">
                <div class="d-block align-center" style="margin: 5px; justify-content: center; align-items: center;">
                    <span v-if="item.composite_admin_profiles_receiver_departments"  style="display: block; white-space:nowrap;">{{`${getReceiversByDepartments(item.composite_admin_profiles_receiver_departments)}`}}</span>
                    <span v-else>{{$t('wkt.admin.common.all')}}</span>
                </div>
            </template>

            <template v-slot:[`item.composite_admin_profiles_permissions`]="{ item }">
                <span>{{ buildProfilePermissions(item) }}</span>
            </template>

            <template v-slot:[`item.avatar_notify`]="{ item }">
                <div style="display:flex;">
                    <v-img max-width="38" max-height="38" style="float:left; margin-left: 5px;" :src="getProfileAssetUrl(item.avatar_notify_url)" />
                    <div style="margin: 10px;">
                        <span v-if="item.avatar_notify_title" class="truncate" style="white-space: nowrap;">
                            {{ item.avatar_notify_title }}
                        </span>
                    </div>
                </div>
            </template>

             <template v-slot:[`item.composite_news_image`]="{ item }">
               <v-img  max-width="38" max-height="38" :src="imagePath(item.composite_news_image_path)" style="float:left; margin: 5px;"></v-img>
            </template>

            <template v-slot:[`item.composite_news_receiver`]="{ item }">
                <div class="d-block align-center" style="margin: 5px; justify-content: center; align-items: center;"></div>
                <div>
                    <span v-if="item.composite_news_receiver_workplaces || item.composite_news_receiver_departments || item.composite_news_receiver_legal_entities"  style="display: block; max-width: 300px; white-space:nowrap;">{{`${getReceiversByWorkplaces(item.composite_news_receiver_workplaces)}`}}</span>  
                </div>   
                <div>
                    <span v-if="item.composite_news_receiver_workplaces || item.composite_news_receiver_departments || item.composite_news_receiver_legal_entities"  style="display: block; max-width: 300px; white-space:nowrap;">{{`${getReceiversByDepartments(item.composite_news_receiver_departments)}`}}</span>   
                </div>   
                <div>
                    <span v-if="item.composite_news_receiver_legal_entities" style="display: block; max-width: 300px; white-space:nowrap;">{{`${getReceiversByLegalEntities(item.composite_news_receiver_legal_entities)}`}}</span>
                </div>
                    <div>
                    <span v-if="item.composite_news_receiver_projects && !item.composite_news_receiver_workplaces && !item.composite_news_receiver_departments && !item.composite_news_receiver_legal_entities"  style="display: block; max-width: 300px; white-space:nowrap;">{{`${getReceiversByProjects(item.composite_news_receiver_projects)}`}}</span>   
                </div> 
                <div>
                    <span v-if="!item.composite_news_receiver_projects && !item.composite_news_receiver_workplaces && !item.composite_news_receiver_departments && !item.composite_news_receiver_legal_entities"  style="display: block; max-width: 300px; white-space:nowrap;">{{$t('wkt.admin.common.all') }}</span>  
                </div>
            </template>

            <template v-slot:[`item.menu`]="{item}">
                <MenuPanel v-if="getFilteredRowMenu(item).length" v-on:menu-selected="onMenuSelected" compact="true" :config="{ menu: getFilteredRowMenu(item) }" :context="item" />
            </template>

        </v-data-table>
     </v-row>

     <v-tooltip left v-if="tableConfig && tableConfig.onAddItem && canModify">
        <template v-slot:activator="{ on, attrs }">				
            <v-btn dark fixed bottom right fab color="#185EA9" :disabled="disableAddButton" v-bind="attrs" v-on="on" @click="onAddItem()">
                <v-icon dark>add</v-icon>
            </v-btn>
        </template>
        <span>{{st(tableConfig.onAddItem.label)}}</span>
    </v-tooltip>

          <ConfirmDialog ref="dlgRefundTransactionConfirm"
            :title="'Solicitar devolución'"
            :message="'¿Quires solicitar la devolución de este importe al cliente?'"
            :titleOk="'Solicitar devolución'"
            :titleCancel="'Cancelar'"
            v-on:confirmed="requestRefund($event)"
        />
          <ConfirmDialog ref="dlgOpenCalendarRulesAssisstantConfirm"
            :title="$t('wkt.admin.calendar.assistant-dialog.title')"
            :message="$t('wkt.admin.calendar.new-exercise-dialog.text')"
            :titleOk="$t('wkt.admin.common.dialog-buttons.yes')"
            :titleCancel="$t('wkt.admin.common.dialog-buttons.no')"                
            v-on:confirmed="openCalendarRulesAssisstant($event)"
        />

        <LoadingDialog :loading="showLoadingDialog" />
    </v-container>
</template>

<script> 

import ExportXlsx from '../../common/ExportXlsx';
import SearchPanel from './SearchPanel'
import MenuPanel from './MenuPanel'
import RefreshWidget from '../../common/RefreshWidget';
import BaseModule from '../../common/BaseModule.js'
import CommonFormatter from '../../common/CommonFormatter.js'
import { Constants } from "../../common/Constants.js";
import api from '../../../api/worktime'
import gwt from '../../../api/gwt'
import { EventBus }  from './../../util/event-bus'
import ConfirmDialog from '../../common/ConfirmDialog'
import LoadingDialog from '../../common/LoadingDialog'

export default {
  name: 'TableWidget',
  mixins: [BaseModule, CommonFormatter],
  components: { 
    SearchPanel, ExportXlsx, MenuPanel, ConfirmDialog, RefreshWidget, LoadingDialog
  },
   props: ['config','context'],
  
  data() {
      return {
        isLoading: true,
        canModify: false,
        disableAddButton: false,
        options: {},
        optionsByModules: {},
        itemsPerPageList: [20, 50, 100],
        headers: [],
        data: [],
        tableConfig: {},
        serverItems: 10,
        tableHeight:undefined,
        childrenContext: {},
        childrenConfig: {},
        filters: [],
        employees: [],
        showLoadingDialog: false
      }
  },mounted() {
        this.$nextTick(() => {    
            this.childrenConfig=this.config.fields?JSON.parse(this.config.fields):{};
            this.childrenContext=this.context;

            let profile = gwt.getSessionProfile();
            let sessionInformation = gwt.getSessionInformation();

            //revisamos permisos
            this.canModify = (!this.config.rolesAllowed || this.matchRoleModify(profile,this.config.rolesAllowed.split(',')));

            //revisamos tipo de licencia
            this.disableAddButton = this.disableLicenseTypeByModule(this.config.id, sessionInformation.company.licenseType);

            console.log(`mounted() called! - company.licenseType: ${sessionInformation.company.licenseType}`);
            console.log(`mounted() called! - canModify: ${this.canModify}`);
            console.log(`mounted() called! - disableAddButton: ${this.disableAddButton}`);
                
            this.update();
            //this.getEmployees();
        });

    },
    computed: {
        getCurrentUserId() {
            return gwt.getSessionInformation().employee.id;
        },
        sessionUserIsSuperAdmin() {
            return gwt.getSessionInformation().employee.isSuperAdmin;
        }
    },
    watch: {
      options: {
        handler () { 
            // Nos guardamos los cambios de la configuración de la tabla en el módulo que toca
            this.optionsByModules[this.config.id] = { ...this.options };
            console.log(`options changed! [ config.id: ${this.config.id} - options: ${JSON.stringify(this.optionsByModules[this.config.id])} ]`);
            this.loadData();
        },
        deep: true,
      },
      config: function(config) { 
        this.$nextTick(() => {
            this.data=[];
            this.childrenConfig=config.fields?JSON.parse(config.fields):{};
            console.log(this.childrenConfig);
        });
      },
      context: function(context) { 
        this.$nextTick(() => {
            let profile = gwt.getSessionProfile();
            let sessionInformation = gwt.getSessionInformation();

            //revisamos permisos
            this.canModify = (!this.config.rolesAllowed || this.matchRoleModify(profile,this.config.rolesAllowed.split(',')));

            //revisamos tipo de licencia
            this.disableAddButton = this.disableLicenseTypeByModule(this.config.id, sessionInformation.company.licenseType);

            console.log(`context() called! - company.licenseType: ${sessionInformation.company.licenseType}`);
            console.log(`context() called! - canModify: ${this.canModify}`);
            console.log(`context() called! - disableAddButton: ${this.disableAddButton}`);

            this.childrenContext=context;
            this.data=[];

            // Pasamos al contexto los filtros que tiene el módulo
            this.childrenContext.filters = this.filters[this.config.id] ? this.filters[this.config.id] : [];
            
            // Al cambiar de módulo, si no existe la configuración de la tabla, la creamos; si existe, reseteamos la paginación
            if (!this.optionsByModules[this.config.id]) {
                this.optionsByModules[this.config.id] = { 
                    sortBy: [], 
                    sortDesc: [], 
                    page: 1, 
                    itemsPerPage: this.itemsPerPageList[0]
                };
            } else {
                this.optionsByModules[this.config.id].page = 1;
            }
            
            // Nos guardamos los cambios de la configuración de la tabla en el módulo que toca, forzando la recarga de datos
            this.options = this.optionsByModules[this.config.id];
            
            console.log(`context changed! reset to page 1 [ config.id: ${this.config.id} - options: ${JSON.stringify(this.optionsByModules[this.config.id])} ]`);
        });
      }
    },
    methods: {
        getFilteredRowMenu(row) {
            if (!this.tableConfig || !this.tableConfig.rowMenu) return [];
            if (this.config.id == 20) {
            if (
                row.composite7_response_code != null &&
                row.composite7_response_code === '0000' &&
                row.composite7_refundDate == null
            ) {
                return this.tableConfig.rowMenu;
            }
            return [];
            } else if (this.config.id == 21) {
            if (
                row.composite_notify_query_action_type != null &&
                row.composite_notify_query_action_type == 3
            ) {
                return this.tableConfig.rowMenu;
            }
            return [];
            } else {
            return this.tableConfig.rowMenu;
            }
        },
        getAbsoluteLink(url) {
            if (!url) return '';
            if (url.startsWith('http://') || url.startsWith('https://')) {
                return url;
            }
            if (url.startsWith('#')) {
                let basePath = window.location.href.split('#')[0];
                return basePath + url;
            }
            return window.location.href;
        },
        onMenuSelected(item) {
        if (item.mode==='CORE') {
                if (item.type === 'EXPORT') {
                    this.exportData();
                    return;
                } else if (item.type === 'LINK') {
                    window.location.href = this.getAbsoluteLink(item.payload);
                    return;
                }

            } else if (item.mode === 'EVENT') {
                if (this.config.id === 17 && item.action === 'OPEN_DIALOG') {
                    this.openHolidaysTableDialog(item.payload);
                    return;
                }
                if (this.config.id === 20 && item.action === 'OPEN_DIALOG') {
                    this.confirmRefund(item.payload);
                    return;
                }
                if (this.config.id === 28 && item.action === 'CALL_PHONE') {                
                    this.makePhoneCall(item.payload);
                } else if (this.config.id === 28 && item.action === 'SEND_EMAIL') {
                    this.sendEmail(item.payload);
                } else if (this.config.id === 31 && item.action === 'DOWNLOAD_XLSX_STAFF') {
                    this.downloadProjectExcel(0, item.payload);
                } else if (this.config.id === 32 && item.action === 'DOWNLOAD_XLSX_STAFF') {
                    this.downloadProjectExcel(0, item.payload);
                } else if (this.config.id === 32 && item.action === 'DOWNLOAD_XLSX_ACTIVITIES') {
                    this.downloadProjectExcel(1, item.payload);
                } else if (this.config.id === 32 && item.action === 'DOWNLOAD_XLSX_PROCEDURES') {
                    this.downloadProjectExcel(2, item.payload);
                } else if (this.config.id === 11 && item.action === 'CREATE_EXERCISE') {
                    this.createNextCalendarExercise(item.payload);
                }
            } else {
                EventBus.$emit('widget-data-click',{ mode:item.mode,type:item.type, action:item.action, payload:item.payload, eventConfig:item});
            }       
        },
        onFilterChange(newFilters) {
            // Guardamos el filtro actualizado en el módulo
            this.filters[this.config.id] = newFilters;
                
            // Cuando los filtros se actualizan, reseteamos la paginación si procede; en caso contrario, forzamos la recarga de datos
            if (this.optionsByModules[this.config.id].page != 1) {
                this.optionsByModules[this.config.id].page = 1;
                
                // Nos guardamos los cambios de la configuración de la tabla en el módulo que toca, forzando la recarga de datos
                this.options = this.optionsByModules[this.config.id];
            } else {
                this.loadData();
            }

            console.log(`onFilterChange() called! [ config.id: ${this.config.id} - options: ${JSON.stringify(this.optionsByModules[this.config.id])} ]`);
        },
        onAddItem() {
            if (!this.tableConfig.onAddItem) {
                return;
            }

            if (this.disableAddButton) {
                this.$emit('show-alert', {
                    text: this.disableLicenseTypeByModule(this.config.id, gwt.getSessionInformation().company.licenseType)
                        ? this.$t(this.checkLicenseTypeByModule(this.config.id, gwt.getSessionInformation().company.licenseType) === 'C'
                            ? 'wkt.admin.common.license-alert.access.title'
                            : 'wkt.admin.common.license-alert.title')
                        : '',
                    color: 'warning',
                    timeout: 4000
                });
                return;
            }

            EventBus.$emit('widget-data-click',{ mode:this.tableConfig.onAddItem.mode,type:this.tableConfig.onAddItem.type, action:this.tableConfig.onAddItem.action, payload:null, eventConfig:this.tableConfig.onAddItem});
        },
        onRowSelected(item) {
            if (!this.tableConfig.onRowSelect) {
                return;
            }
            EventBus.$emit('widget-data-click',{ mode:this.tableConfig.onRowSelect.mode,type:this.tableConfig.onRowSelect.type, action:this.tableConfig.onRowSelect.action, payload:item[this.tableConfig.onRowSelect.payload], eventConfig:this.tableConfig.onRowSelect});
        },
        loadData() {
            if (!this.config && !this.config.fields) {
                return;
            }
            const me = this;
            me.isLoading=true;
            this.tableConfig = JSON.parse(me.config.fields);
            const fields = this.tableConfig.headers?this.tableConfig.headers:this.tableConfig;
            me.headers = [];

            for(var k in fields) {
                    let item = fields[k];
                    item['value'] = item['field'];
                    item['text'] = this.st(item['label']);
                    item['desc'] = this.st(item['desc']);
                    item['label'] = this.st(item['label']);
                    item['field'] = this.translateSortBy(item['field']);
                    me.headers.push(item);
                }

            if (this.tableConfig.rowMenu && this.tableConfig.rowMenu.length>0) {

                let item = {
                    value:'menu',
                    sortable:false,
                    width:'20px',
                    exportIgnore: true
                }
                me.headers.push(item);
            }

            const { sortBy, sortDesc, page, itemsPerPage } = this.optionsByModules[this.config.id];

            let queryContext = {
                'sortBy':sortBy.length>0?this.translateSortBy(sortBy[0]):null,
                'sortDesc':sortDesc.length>0?sortDesc[0]:null,
                workplaceIds: this.context.workplaceIds,
                departmentIds: this.context.departmentIds,
                parentModuleId: this.context.parentModuleId,
                offset: (page-1) * itemsPerPage,
                count: itemsPerPage,
                filters: this.filters[this.config.id] ? this.filters[this.config.id] : []
            };

            api.getModuleData(this.config.id, queryContext, (res) => {
                me.isLoading=false;
                me.addCustomData(me, res);
                me.data = me.formatData(me,res);
                me.fixLayout(me);
                me.serverItems = (page-1) * itemsPerPage + res.length + (itemsPerPage == res.length?1:0);

                if (me.$refs.refresh) {
                    me.$refs.refresh.update();
                }
            }, err => {
                alert(err);
                this.isLoading=false;
            })
        },
        translateSortBy(field) {
            if (field == 'avatar') {
                return 'avatar_title';
            } 
            if (field == 'composite1') {
                return 'composite1_title';
            } 
            if (field == 'composite2') {
                return 'composite2_title';
            } 
            if (field == 'composite3') {
                return 'composite3_title';
            }  
            if (field == 'composite3_1') {
                return 'composite3_1_total_amount ';
            }  
            if (field == 'composite3_2') {
                return 'composite3_2_companyName ';
            }   
            if (field == 'composite4') {
                return 'composite4_title';
            } 
            if (field == 'composite5') {
                return 'composite5_firstname';
            }
            if (field == 'composite6') {
                return 'composite6_firstname';
            }
            if (field == 'composite7') {
                return 'composite7_response_code';
            }
            if (field == 'composite8') {
                return 'composite8_transaction_type';
            }
            if (field == 'composite9') {
                return 'composite9_firstname';
            }
            if (field == 'composite13') {
                return 'composite13_accessType';
            }
            if (field == 'avatar_disabled_telework_employee') {
                return 'avatar_disabled_telework_employee_subtitle'
            }
            if (field == 'composite_status_telework_employee') {
                return 'composite_status_telework_employee_working';
            }
            if (field == 'composite_available_telework_employee') {
                return 'composite_available_telework_employee_start';
            }
            if (field == 'composite_expensesheet_approval') {
                return 'composite_expensesheet_approval_employees';
            }
            if (field == 'composite_expensesheetitem_taxes') {
            return 'composite_expensesheetitem_taxes_amount';
            }
            if (field == 'composite_expensesheetitem_vendor') {
                return 'composite_expensesheetitem_vendor_name';
            }
            if (field == 'composite_team_info') {
                return 'composite_team_short_name';
            }
            if(field == 'avatar_disabled_admin_profiles') {
                return 'composite_admin_profiles_employee_email'
            }
            if(field == 'composite_admin_profiles_employee') {
                return 'avatar_disabled_admin_profiles_title'
            }
            if(field == 'composite_admin_profiles_permissions') {
                return 'composite_admin_profiles_permissions_home'
        }
            if (field == 'avatar_notify') {
                return 'avatar_notify_title';
            }
            if (field == 'composite_notify_receiver') {
                return 'composite_notify_receiver_type';
            }
            if (field == 'composite_news_image') {
                return 'composite_news_image_path';
            }
            if (field == 'composite_news_receiver') {
                return 'composite_news_receiver_workplaces';
            }
            return field;
        },
        exportData() {
            this.$refs.exportXlsx.$el.click();
        },
        openHolidaysTableDialog(item) {     
            this.$refs.openHolidaysTableDialog.confirm(item);
        },
        confirmRefund(transactionId) {
            this.$refs.dlgRefundTransactionConfirm.confirm(transactionId);
        },
        requestRefund(transactionId) {
            this.loading = true;
            // eslint-disable-next-line no-unused-vars
            api.refundTransaction(transactionId,res => {
                    this.loading = false;
                if (res.rsOK) {
                    this.update();  
                        this.$emit('show-alert',{ text: res.message, color: 'green', timeout: 3000 });
                } else {
                    this.$emit('show-alert',{ text: res.message, color: 'error', timeout: 3000 });
                }
            },
            error => {
                this.$log.error(error);
                this.loading = false;
                this.$emit('show-alert',{ text: error.message, color: 'error', timeout: 3000 });
            });
        },
        // Método para abrir el cliente de correo predeterminado
        sendEmail(emailAddress) {
            window.location.href = `mailto:${emailAddress}`;
        },
        // Método para realizar una llamada telefónica
        makePhoneCall(phoneNumber) {
            window.location.href = `callto:${phoneNumber}`;
        }, 
        downloadProjectExcel(reportType, projectId) {
            const project = this.data.find(x => x.id === projectId);

            let name = null;
            let type = null;

            switch (reportType) {
                case 0:
                    name = project.project_type === 0 ? "projectSummaryStaffExcel" : "teamSummaryStaffExcel";
                    type = "work team";
                    break;
                case 1:
                    name = "projectSummaryActivitiesExcel";
                    type = "activities";
                    break;
                case 2:
                    name = "projectSummaryProceduresExcel";
                    type = "requests";
                    break;
            }

            gwt.downloadFile(`report/${name}/${project.id}`, `${project.short_name} - ${type}.xlsx`);
        },
        createNextCalendarExercise(calendarId) {
            this.showLoadingDialog = true;
            api.createNextCalendarExercise(calendarId,
                () => {
                    this.showLoadingDialog = false;
                    this.update();

                    this.$refs.dlgOpenCalendarRulesAssisstantConfirm.confirm(calendarId);
                },
                (error) => {
                    this.$log.error(error);
                    this.showLoadingDialog = false;
                    this.$emit('show-alert',{ text: error.message, color: 'error', timeout: 3000 });
                }
            );
        },
        openCalendarRulesAssisstant(calendarId) {
            const payload = { 
                calendarId: calendarId, 
                openRules: true
            };

            gwt.fireEvent('OpenCalendarEvent', JSON.stringify(payload));
        },
        update() {
            this.loadData(this);
        },
        updateData() {
            this.loadData(this);
        },
        fixLayout(vm) {
            this.$nextTick(() => {
                vm.tableHeight = window.getComputedStyle(vm.$refs.dataTable.$el, null).getPropertyValue("max-height")-100;
            });
        },
        downloadPurchaseBill(purchaseId) {
            gwt.downloadFile(`report/billProduct/${purchaseId}`, `bill-${purchaseId}.pdf`);
        },
        /*getExpenseSheetStatusColor(status) {
            let color = "green";

            switch (status) {
                case -1: // PREPARING
                case 0: // PENDING
                    color = "orange";
                    break; 
                case 2: // CANCELED
                case 3: // DECLINED
                    color = "red";
                    break;
                case 4: // PROCESSED
                    color = "#2196F3";
                    break;
            }

            return color;
        },
        getExpenseSheetStatusText(status) {
            let text = "";

            switch (status) {
                case -1: // PREPARING
                    text = this.$t('wkt.admin.expensesheet.status-type.preparing');
                    break;
                case 0: // PENDING
                    text = this.$t('wkt.admin.expensesheet.status-type.pending');
                    break;
                case 1: // APPROVED
                    text = this.$t('wkt.admin.expensesheet.status-type.approved');
                    break;
                case 2: // CANCELED
                    text = this.$t('wkt.admin.expensesheet.status-type.denied');
                    break;
                case 3: // DECLINED
                    text = this.$t('wkt.admin.expensesheet.status-type.canceled');
                    break;
                case 4: // PROCESSED
                    text = this.$t('wkt.admin.expensesheet.status-type.processed');
                    break;
            }

            return text.toUpperCase();
        },*/   
        /*getEmployees() {
            if (gwt.getDepartments()) {
                this.getAllEmployees(gwt.getDepartments());
                return;
            }

            this.loading = true;

            api.getStaff(
                data => {
                    this.loading = false;
                    this.getAllEmployees(data);
                }, 
                error => {
                this.$log.error(error);
                this.loading = false;
                this.$emit('show-alert',{ text: error.message, color: 'error', timeout: 3000 });
                }
            );
        },
        getAllEmployees(departments) {
            this.employees = [];

            for (let i = 0; i < departments.length; i++) {
                this.employees = [...this.employees, ...departments[i].employees];
            }
        },*/
        /*getApproverEmployeeNames(employeeIds) {
            if (!employeeIds || employeeIds.length === 0) {
                return;
            }

            const ids = employeeIds.split(',').map(e => Number(e));

            if (ids.length === 0) {
                return;
            }

            let names = '';

            for (let i = 0; i < ids.length; i++) {
                const employee = this.employees.find(e => e.id === ids[i]);
                
                if (!employee) {
                    continue;
                }

                names += `${employee.lastname}, ${employee.firstname}`;

                if (i < ids.length - 1) {
                    names += ' | ';
                }
            }

            return names;
        },*/
        downloadExpenseSheetItemDocument(item) {
            this.loading = true;

            api.downloadExpenseSheetItemDocument(item.sheet_id, item.id,
                () => {
                    this.loading = false;
                }, 
                error => {
                this.$log.error(error);
                this.loading = false;
                this.$emit('show-alert',{ text: error.message, color: 'error', timeout: 3000 });
                }
            );
        },
        getReceiversByWorkplaces(entityIds) {
            let text = "";
            if (entityIds !== null) {
                text = this.getWorkplaceNamesFromStringIds(entityIds);
            } else {
                text = this.$t('wkt.admin.elements.access-type-element.all_workplaces');
            }
            return text;
        },
        getReceiversByDepartments(entityIds) {
            let text = "";
            if (entityIds !== null) {
                text = this.getDepartmentNamesFromStringIds(entityIds);
            } else {
                text = this.$t('wkt.admin.elements.access-type-element.all_departments');
            }
            return text;
        },
        getReceiversByLegalEntities(entityIds) {
            let text = "";
            if (entityIds !== null) {
                text = this.getLegalEntityNamesFromStringIds(entityIds);
            } else {
                text = this.$t('wkt.admin.application.global-filter.all_legal_entities');
            }
            return text;
        },
        getReceiversByProjects(entityIds) {
            let text = "";
            if (entityIds !== null) {
                text = this.getProjectNamesFromStringIds(entityIds);
            } else {
                text = this.$t('wkt.admin.elements.access-type-element.all_projects');
            }
            return text;
        },
        getReceiversByEmployees(entityIds){
            let text = "";
            text = this.getEmployeeNamesFromStringIds(entityIds);
            return text;
        },
        getIconType(item) {
            if (item.composite_status_telework_employee_telework == '0') {
                return 'domain';
            } else {
                return 'home';
            }
        },
        getIconColor(item) {
        // Verifica si la fecha de calendario es la fecha actual
        if (item.composite_status_telework_employee_calendar !== null && item.composite_status_telework_employee_calendar === this.formatISODate(new Date())) {
            // Verifica si el empleado está trabajando
            if (item.composite_status_telework_employee_working == '1') {
                return 'green'; // Activo
            } else if (item.composite_status_telework_employee_device !== null) {
                return 'deep-orange lighten-3'; // Jornada finalizada (dispositivo registrado)
            } else if (item.composite_status_telework_employee_total_activity_hours > 0) {
                return 'amber lighten-2'; // Descansando (actividad registrada)
            } else {
                return 'grey lighten-2'; // Jornada no comenzada
            }
        } else {
            return 'grey lighten-2'; // Fecha de calendario diferente, estado no aplicable
        }
        },

        getTooltipText(item) {
        let text = '';
        // Agrega el estado de teletrabajo o presencial
        if (item.composite_status_telework_employee_telework == '1') {
            text += this.$t('wkt.admin.elements.workday-element.icon-telework.teleworking') + ' - ';
        } else {
            text += this.$t('wkt.admin.elements.workday-element.icon-telework.inoffice') + ' - ';
        }
        // Verifica si la fecha de calendario es la fecha actual
        if (item.composite_status_telework_employee_calendar !== null && item.composite_status_telework_employee_calendar ===this.formatISODate(new Date())) {
            // Determina el estado y agrega el texto correspondiente
            if (item.composite_status_telework_employee_working == '1') {
                text += this.$t('wkt.admin.elements.workday-element.icon-telework.working');
            } else if (item.composite_status_telework_employee_device !== null) {
                text += this.$t('wkt.admin.elements.workday-element.icon-telework.finished');
            } else if (item.composite_status_telework_employee_total_activity_hours > 0) {
                text += this.$t('wkt.admin.elements.workday-element.icon-telework.resting');
            } else {
                text += this.$t('wkt.admin.elements.workday-element.icon-telework.notstarted');
            }
        }
        return text;
        },
        buildProfilePermissions(item) {
            let denyAll = 0, readOnly = 0, readWrite = 0;

            const count = (permission) => {
                const perm = permission ?? Constants.DENY_ALL;
                switch(perm) {
                    case Constants.DENY_ALL: denyAll++; break;
                    case Constants.ALLOW_READ_ONLY: readOnly++; break;
                    case Constants.ALLOW_READ_WRITE: readWrite++; break;
                }
            };

            count(item.composite_admin_profiles_permissions_home);
            count(item.composite_admin_profiles_permissions_messages);
            count(item.composite_admin_profiles_permissions_news);
            count(item.composite_admin_profiles_permissions_telework);
            count(item.composite_admin_profiles_permissions_daily);
            count(item.composite_admin_profiles_permissions_monthly);
            count(item.composite_admin_profiles_permissions_employee);
            count(item.composite_admin_profiles_permissions_procedures);
            count(item.composite_admin_profiles_permissions_documents);
            count(item.composite_admin_profiles_permissions_pdocuments);
            count(item.composite_admin_profiles_permissions_hcalendar);
            count(item.composite_admin_profiles_permissions_holidays);
            count(item.composite_admin_profiles_permissions_staff);
            count(item.composite_admin_profiles_permissions_assessments);
            count(item.composite_admin_profiles_permissions_projects); 
            count(item.composite_admin_profiles_permissions_teams);
            count(item.composite_admin_profiles_permissions_planning);
            count(item.composite_admin_profiles_permissions_surveys);
            count(item.composite_admin_profiles_permissions_ai);

            if (this.sessionUserIsSuperAdmin) {
                count(item.composite_admin_profiles_permissions_customers);
                count(item.composite_admin_profiles_permissions_partners);
                count(item.composite_admin_profiles_permissions_transactions);
                count(item.composite_admin_profiles_permissions_purchases);
                count(item.composite_admin_profiles_permissions_prices);
                count(item.composite_admin_profiles_permissions_vouchers);
                count(item.composite_admin_profiles_permissions_onBoardMessages);
                count(item.composite_admin_profiles_permissions_webhooks);
                count(item.composite_admin_profiles_permissions_report_type);
                count(item.composite_admin_profiles_permissions_adminconfig);
            }

            count(item.composite_admin_profiles_permissions_gconfig);
            count(item.composite_admin_profiles_permissions_profiles);
            count(item.composite_admin_profiles_permissions_workplace);
            count(item.composite_admin_profiles_permissions_departments);
            count(item.composite_admin_profiles_permissions_legal_entity);
            count(item.composite_admin_profiles_permissions_calendar);
            count(item.composite_admin_profiles_permissions_vpolicy);
            count(item.composite_admin_profiles_permissions_pforms);
            count(item.composite_admin_profiles_permissions_pdefinition);
            count(item.composite_admin_profiles_permissions_activities_type);
            count(item.composite_admin_profiles_permissions_chatconfig);
            count(item.composite_admin_profiles_permissions_gcustomize);
            count(item.composite_admin_profiles_permissions_integration);
            count(item.composite_admin_profiles_permissions_license);
            count(item.composite_admin_profiles_permissions_private_documents);
            count(item.composite_admin_profiles_permissions_paid_absences_category);
            count(item.composite_admin_profiles_permissions_additional_hours_category);

            return `${this.$t('wkt.admin.profiles.deny_all')}${denyAll}, 
                    ${this.$t('wkt.admin.profiles.read_only')}${readOnly}, 
                    ${this.$t('wkt.admin.profiles.read_write')}${readWrite}`;
        },
        imagePath(imagePath) {
            if (!imagePath || imagePath.trim().length === 0) {
            return "img/default-news.jpeg";
            }

            const bucketName = "worktime-dev"; // TODO: obtener de configuración
            return "https://storage.googleapis.com/" + bucketName + "/" + imagePath;
        },
   }
};
</script>
